import {animated, useSpring} from "@react-spring/web";
import {useState} from "react";

function StartState() {
    const [enabled, setEnabled] = useState<boolean>(true);

    const springs = useSpring({
        delay: 1200,
        from: { opacity: 1 },
        to: { opacity: 0 },
        onResolve: _ => setEnabled(false)
    })

    if (!enabled) {
        return <></>
    }

    return (
        <animated.div className={'layout vertical'} style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100vh',
            backgroundColor: 'rgba(0,0,0)',
            alignItems: 'center',
            justifyContent: 'center',
            ...springs
        }}>
            <img alt={'logo'} src={'./rooms-of-liberation-logo.png'} style={{width: '300px', height: '300px'}}/>
        </animated.div>
    )
}

export default StartState;
